import { Globe } from 'lucide-react';
import {
  SiFacebook, SiInstagram, SiX, SiYoutube,
  SiTiktok, SiSpotify, SiApplemusic, SiSoundcloud,
} from 'react-icons/si';

const SOCIAL_PLATFORMS = [
  { key: 'facebook_url',    label: 'Facebook',    Icon: SiFacebook,   placeholder: 'https://facebook.com/yourband',        atSign: false },
  { key: 'instagram_url',   label: 'Instagram',   Icon: SiInstagram,  placeholder: 'https://instagram.com/yourband',       atSign: true  },
  { key: 'twitter_url',     label: 'Twitter / X', Icon: SiX,          placeholder: 'https://x.com/yourband',               atSign: true  },
  { key: 'youtube_url',     label: 'YouTube',     Icon: SiYoutube,    placeholder: 'https://youtube.com/@yourband',        atSign: true  },
  { key: 'tiktok_url',      label: 'TikTok',      Icon: SiTiktok,     placeholder: 'https://tiktok.com/@yourband',         atSign: true  },
  { key: 'spotify_url',     label: 'Spotify',     Icon: SiSpotify,    placeholder: 'https://open.spotify.com/artist/...',  atSign: false },
  { key: 'apple_music_url', label: 'Apple Music', Icon: SiApplemusic, placeholder: 'https://music.apple.com/...',          atSign: false },
  { key: 'soundcloud_url',  label: 'SoundCloud',  Icon: SiSoundcloud, placeholder: 'https://soundcloud.com/yourband',      atSign: false },
  { key: 'website_url',     label: 'Website',     Icon: Globe,        placeholder: 'https://yourband.com',                 atSign: false },
];

export default SOCIAL_PLATFORMS;
